// Tiny pub/sub so useFavorites can announce a *new* save without knowing about
// the UI that shows the confirmation. The global <SaveConfirmation> component
// subscribes and renders the branded snackbar. No subscribers (e.g. in tests)
// = a harmless no-op.

export interface SavedCafe {
  cafeId: string;
  cafeName: string;
}

type Listener = (cafe: SavedCafe) => void;

const listeners = new Set<Listener>();

/** Subscribe to "a café was just newly saved" events. Returns an unsubscribe fn. */
export function onCafeSaved(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Fired by useFavorites when a NEW favorite is added — not on unsave, and not
 *  on a no-op duplicate (already-favorited). */
export function emitCafeSaved(cafe: SavedCafe): void {
  listeners.forEach((listener) => listener(cafe));
}
